import Vue from 'vue'
import Home from './views/Home.vue'
import Pricing from './views/Pricing.vue'
import Products from './views/Products.vue'
import Payment from './views/Payment.vue'

import About from './views/About.vue'
import TermsOfUse from './views/TermsOfUse.vue'
import PrivacyPolicy from './views/PrivacyPolicy.vue'
import Dmca from './views/DMCA.vue'

import SignUp from './views/SignUp.vue'
import ContactUs from './views/ContactUs.vue'
import Subscribe from './views/Subscribe.vue'
import Careers from './views/Careers.vue'

import { createWebHistory, createRouter } from "vue-router";
import Alpha from "@/views/Alpha.vue";




// const router = new VueRouter({
//   mode: 'history',
//   scrollBehavior: (to, from, savedPosition) => ({ y:0}),
//   scrollBehavior: (to, from, savedPosition) {
//     if (to.hash) {
//       return {
//         selector: to.hash
//       }
//     }
//   },
//   // routes: [
//   //   { path: '/', component: App }

//   // ]
// })

const router = createRouter({
  mode: 'history',
  history: createWebHistory(),
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      let position = {};
      position.selector = to.hash;
      position.offset = { x: 0, y: -100 }
      // if (to.hash === '/Pricing#promotion-lite') {
      // }

      return position;
    }
    return savedPosition || { x: 0, y: 0 };

  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      meta: { title: 'Seedr - Home' },
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      meta: { title: 'Seedr - About' },
      component: About
    },
    {
      path: '/pricing',
      name: 'pricing',
      meta: { title: 'Seedr - Premium' },
      component: Pricing
    },
    {
      path: '/products',
      name: 'products',
      meta: { title: 'Seedr - Products' },
      component: Products
    },    {
      path: '/payment',
      name: 'payment',
      meta: { title: 'Seedr - Premium' },
      component: Payment
    },
    {
      path: '/termsofuse',
      name: 'ternsofuse',
      meta: { title: 'Seedr - Terms Of Use' },
      component: TermsOfUse
    },
    {
      path: '/privacypolicy',
      name: 'privacypolicy',
      meta: { title: 'Seedr - Privacy Policy' },
      component: PrivacyPolicy
    },
    {
      path: '/dmca',
      name: 'dmca',
      meta: { title: 'Seedr - DMCA' },
      component: Dmca
    },
    {
      path: '/signup',
      name: 'signUp',
      meta: { title: 'Seedr - Sign Up' },
      component: SignUp
    },
    {
      path: '/v2/alpha',
      name: 'alpha',
      meta: { title: 'Seedr - Alpha Registration' },
      component: Alpha
    },
    {
      path: '/contactus',
      name: 'contactus',
      meta: { title: 'Seedr - Contact Us' },
      component: ContactUs
    },
    {
      path: '/subscribe',
      name: 'subscribe',
      meta: { title: 'Seedr - Subscribe' },
      component: Subscribe
    }, {
      path: '/carrers',
      name: 'careers',
      meta: { title: 'Seedr - Careers' },
      component: Careers
    }
  ]
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Seedr';
  next();
});

export default router
